import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Card, CardContent } from "../components/ui/card";
import { Shield } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-sand">
      <Header />
      
      <main className="pt-24 pb-12 px-4 md:px-8 max-w-4xl mx-auto" data-testid="terms-page">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-forest/10 mb-4">
            <Shield className="w-8 h-8 text-forest" />
          </div>
          <h1 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 mb-4">
            Terms of Service
          </h1>
          <p className="text-gray-600">Last updated: January 2026</p>
        </div>

        <Card className="border-stone-200">
          <CardContent className="p-8 prose prose-gray max-w-none">
            <h2 className="font-heading">1. Acceptance of Terms</h2>
            <p>
              By accessing or using BQL - Best Quality Leads ("Platform"), you agree to be bound by these Terms of Service ("Terms"). 
              If you do not agree to these Terms, you may not use the Platform.
            </p>

            <h2 className="font-heading">2. Intellectual Property Rights</h2>
            <p>
              <strong>Copyright Notice:</strong> All content, design, graphics, compilation, and other matters related to the Platform 
              are protected under applicable copyright and trademark laws. © {new Date().getFullYear()} BQL - Best Quality Leads. All Rights Reserved.
            </p>
            <p>
              The BQL™ name, logo, and all related names, logos, product and service names, designs, and slogans are 
              trademarks of BQL - Best Quality Leads or its affiliates. You must not use such marks without prior written permission.
            </p>
            <p>
              <strong>Prohibited Actions:</strong>
            </p>
            <ul>
              <li>Copying, reproducing, or distributing any content from this Platform without express written consent</li>
              <li>Modifying, adapting, or creating derivative works based on the Platform</li>
              <li>Reverse engineering, decompiling, or disassembling any software used in the Platform</li>
              <li>Using any automated system to access or scrape content from the Platform</li>
              <li>Removing or altering any copyright, trademark, or other proprietary notices</li>
            </ul>

            <h2 className="font-heading">3. User Accounts</h2>
            <p>
              To access certain features, you must create an account. You are responsible for maintaining the confidentiality 
              of your account credentials and for all activities under your account.
            </p>

            <h2 className="font-heading">4. Customer Terms</h2>
            <p>
              Customers may post jobs for free. By posting a job, you grant ServiceLink a license to display your job listing 
              to professionals on the Platform. You represent that all information provided is accurate and truthful.
            </p>

            <h2 className="font-heading">5. Professional Terms</h2>
            <p>
              Professionals must subscribe to access and bid on leads. Subscription fees are non-refundable except as required 
              by law. Professionals are responsible for the quality of their services and must comply with all applicable laws.
            </p>

            <h2 className="font-heading">6. Payment Terms</h2>
            <p>
              All payments are processed through secure third-party payment processors. By subscribing, you authorize us to 
              charge your payment method for the subscription fee. Subscriptions automatically renew unless cancelled.
            </p>

            <h2 className="font-heading">7. Limitation of Liability</h2>
            <p>
              ServiceLink is a platform connecting customers and professionals. We do not employ, endorse, or guarantee the 
              quality of any professional. We are not liable for any disputes, damages, or losses arising from interactions 
              between users.
            </p>

            <h2 className="font-heading">8. DMCA Notice</h2>
            <p>
              If you believe your copyrighted work has been infringed, please send a DMCA notice to our designated agent at 
              bqleadz@gmail.com with: (a) identification of the copyrighted work, (b) identification of the infringing 
              material, (c) your contact information, and (d) a statement of good faith belief.
            </p>

            <h2 className="font-heading">9. Termination</h2>
            <p>
              We reserve the right to terminate or suspend your account immediately, without prior notice, for any breach of 
              these Terms or for any other reason at our sole discretion.
            </p>

            <h2 className="font-heading">10. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict 
              of law principles.
            </p>

            <h2 className="font-heading">11. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting. 
              Your continued use of the Platform constitutes acceptance of the modified Terms.
            </p>

            <h2 className="font-heading">12. Contact</h2>
            <p>
              For questions about these Terms, contact us at:<br />
              Email: bestqualityleads@bqleadsprogigs.com<br />
              BQL - Best Quality Leads
            </p>

            <div className="mt-8 p-4 bg-sand rounded-xl">
              <p className="text-sm text-gray-600 mb-0">
                <strong>© {new Date().getFullYear()} BQL - Best Quality Leads.</strong> This platform, including all content, features, 
                and functionality, is owned by BQL - Best Quality Leads and is protected by international copyright, trademark, patent, 
                trade secret, and other intellectual property or proprietary rights laws.
              </p>
            </div>
          </CardContent>
        </Card>
      </main>

      <Footer />
    </div>
  );
}
